import React, { useEffect, useMemo } from 'react';
import { SettingsBreadcrumbs } from '../settingsModule';
import { Breadcrumb } from '../../shared/web/layout/Breadcrumbs';
import TeamSetupAreasList from './TeamSetupAreasList';
import { NewTransactionsManagementToggleWrapper } from 'feature-toggle';
import { useTeamSetupAreasContextRequired } from './TeamSetupAreasContext';
import useProjectNavigator from '../../projects/projectNavigator';

function useMarketSetupRedirect() {
  const teamSetupAreasContext = useTeamSetupAreasContextRequired();

  const teamSetupAreas = teamSetupAreasContext.teamSetupAreas;

  const wasEmpty = useMemo(() => teamSetupAreas.length === 0, []);

  const projectsNavigator = useProjectNavigator();

  useEffect(() => {
    if (wasEmpty && teamSetupAreas.length === 1) {
      projectsNavigator.openProjectsPage();
    }
  }, [teamSetupAreas.length]);
}

export default function MarketsPage() {
  useMarketSetupRedirect();

  return (
    <NewTransactionsManagementToggleWrapper>
      <SettingsBreadcrumbs>
        <Breadcrumb text="Markets & Processes" />
      </SettingsBreadcrumbs>
      <TeamSetupAreasList />
    </NewTransactionsManagementToggleWrapper>
  );
}
